"use client";
import { jsx as r } from "react/jsx-runtime";
import { memo as s } from "react";
import { D as c, M } from "../../../ModalBase-CANcLFh0.js";
import { useModalContext as f } from "./ModalProvider.js";
const i = s(
  ({
    variant: o = "auto",
    onClose: m,
    dismissible: e = !0,
    classNames: a,
    style: d,
    children: n,
    ...u
  }) => {
    const { isOpen: t, closeModal: l } = f(), p = o === "fixed" || o === "auto" ? "bottom" : o;
    return /* @__PURE__ */ r(
      c.Root,
      {
        shouldScaleBackground: !0,
        direction: p,
        dismissible: e,
        open: t,
        onOpenChange: m || l,
        ...u,
        children: /* @__PURE__ */ r(
          M,
          {
            isOpen: t,
            dismissible: e,
            variant: o,
            classNames: a,
            style: d,
            children: n
          }
        )
      }
    );
  }
);
i.displayName = "RouterModal";
export {
  i as RouterModal
};
